import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as o, normalizeClass as n, createElementVNode as e } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconGoogleGlyph",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20.64 12.205c0-.639-.057-1.252-.164-1.841H12v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z",
  fill: "#4285F4"
}, null, -1), u = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 21c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H3.957v2.332A8.997 8.997 0 0 0 12 21Z",
  fill: "#34A853"
}, null, -1), h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.964 13.71A5.41 5.41 0 0 1 6.682 12c0-.593.102-1.17.282-1.71V7.958H3.957a9.005 9.005 0 0 0 0 8.084l3.007-2.332Z",
  fill: "#FBBC05"
}, null, -1), p = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 6.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C16.463 3.891 14.426 3 12 3a8.997 8.997 0 0 0-8.043 4.958l3.007 2.332C7.672 8.163 9.656 6.58 12 6.58Z",
  fill: "#EA4335"
}, null, -1), f = [
  _,
  u,
  h,
  p
];
function m(a, v, d, g, b, l) {
  return o(), i("svg", {
    "aria-label": d.ariaLabel,
    class: n([l.iconSizeClass, "d-icon d-icon--google-glyph"]),
    "data-qa": l.dataQA,
    "aria-hidden": l.ariaHidden,
    role: "img",
    "data-name": "Google Glyph",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 10, c);
}
const I = /* @__PURE__ */ r(s, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=google-glyph.js.map
